import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Initial state
const initialState = {
    contracts: [],
    filteredContracts: [],
    loading: false,
    error: null,
};

// Thunk to fetch contracts from API
export const fetchContracts = createAsyncThunk(
    'contracts/fetchContracts',
    async ({ userId,startDate,endDate, language, token }) => {
        const response = await axiosInstance.post('/api/Customer/GetContractByCustomerId',
            { customerId: userId,
                startDate: startDate, 
                endDate: endDate,   
                status: true, 
             },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "lang": language === "English" ? "2" : "1",
                },
            }


        );
        // console.log("response",response);

        return response.data.message || [];
    }
);

const contractsSlice = createSlice({
    name: 'contracts',
    initialState,
    reducers: {
        filterContracts: (state, action) => {
            const { searchValue, startDate, endDate } = action.payload;
            let filtered = state.contracts;

            // Filter by contract name search
            if (searchValue) {
                filtered = filtered.filter(contract =>
                    contract.contractName.toLowerCase().includes(searchValue.toLowerCase())
                );
            }

            // Filter by start and end dates
            if (startDate) {
                filtered = filtered.filter(contract =>
                    new Date(contract.startDate) >= new Date(startDate)
                );
            }
            if (endDate) {
                filtered = filtered.filter(contract =>
                    new Date(contract.endDate) <= new Date(endDate)
                );
            }

            state.filteredContracts = filtered;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContracts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchContracts.fulfilled, (state, action) => {
                state.contracts = action.payload;
                state.filteredContracts = action.payload; // Initialize filteredContracts
                state.loading = false;
            })
            .addCase(fetchContracts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { filterContracts } = contractsSlice.actions;

export default contractsSlice.reducer;
